import EqualsIcon from "../images/EqualsIcon.mjs";

/**
 * App icon for equivalences file
 * @see {GlyphIcon}
 * @see {EqualsIcon}
 */
const AppEquivalencesIcon = class extends EqualsIcon {}

export default AppEquivalencesIcon;